import { VerticalSpace } from '@chargeafter/ui';
import { Box, Dialog, Typography } from '@mui/material';
import { styled } from '@mui/system';

import { useEffect, useState } from 'react';
import { useGetSdkDisplayed } from '../services/flowManager';

const Container = styled(Box)(() => ({
  height: '70vh',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
}));

const StyledDialog = styled(Dialog)(() => ({
  zIndex: 1400,
}));

export const VerticalModeBlocker = () => {
  const sdkDisplayed = useGetSdkDisplayed();
  const portrait = window.matchMedia('(orientation: portrait)');
  const [blockVerticalMode, setBlockVerticalMode] = useState(portrait.matches);
  const handleChangeOrientation = (e: MediaQueryListEvent) => {
    setBlockVerticalMode(!sdkDisplayed && e.matches);
  };

  useEffect(() => {
    portrait.addEventListener('change', handleChangeOrientation);
    setBlockVerticalMode(!sdkDisplayed && portrait.matches);
    return () =>
      portrait.removeEventListener('change', handleChangeOrientation);
  }, [sdkDisplayed]);

  return (
    <StyledDialog fullScreen open={blockVerticalMode}>
      <Container>
        <Typography variant="h7" component="h2">
          Vertical mode is not supported
        </Typography>
        <VerticalSpace units={2} />
        <Typography width="80%" align="center" variant="body1" component="p">
          Vertical viewing is not supported for this application. Please rotate
          your device to the horizontal orientation to proceed.
        </Typography>
      </Container>
    </StyledDialog>
  );
};
